import { X } from "lucide-react";
import { cn } from "@/lib/utils";

type ModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
  children: React.ReactNode;
  size?: "md" | "lg" | "xl";
};

export function Modal(props: ModalProps) {
  if (!props.isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] ">
      <div
        className={cn(
          "bg-white rounded-2xl w-full p-6 relative max-h-screen overflow-auto",
          props.size === "xl"
            ? "max-w-6xl"
            : props.size === "lg"
              ? "max-w-4xl"
              : "max-w-md"
        )}
      >
        <div className="flex justify-between items-center mb-4">
          {props.title ? (
            <h2 className="text-xl font-bold">{props.title}</h2>
          ) : (
            <div />
          )}
          {props.onClose && (
            <button
              onClick={props.onClose}
              className="rounded-full p-1 hover:bg-gray-100"
            >
              <X size={20} />
            </button>
          )}
        </div>
        {props.children}
      </div>
    </div>
  );
}

export default Modal;
